import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';

interface CancelAutomationReportStepParams {
	stepStatusId: string;
}

export const useCancelAutomationReportStepMutation = () => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({ stepStatusId }: CancelAutomationReportStepParams) => {
			const url = Api.ImpersonationBroker.composeApiUrl({
				urlPath: `Automation/Step/${encodeURIComponent(stepStatusId)}`,
			});

			return userSession.webServiceHelper.callAsync<Api.IAutomationStepStatus>(url, 'DELETE', null);
		},
	});
};
